import React, { useState } from "react";
import "../App.css";
import { Link, Outlet } from "react-router-dom";
import config from "../config";
import { useNavigate } from "react-router-dom";
import bannerImg from "../assets/images/Banner.jpeg";
import logoImg from "../assets/images/main_logo.png";

function Hero() {
  const navigate = useNavigate();
  const [activateAdding, setActivateAdding] = useState(false);

  const sendMail = async (e) => {
    e.preventDefault();
    if (!e.target[1].value.includes("@")) {
      alert("Gib wenigstens eine echte E-Mail an");
      return;
    }
    await fetch(`${config.BaseUrl}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: e.target[0].value,
        email: e.target[1].value,
        message: e.target[2].value,
      }),
    });
    alert("email gesendet");
  };

  return (
    <div className="App">
      <nav className="nav">
        <div className="nav-inner">
          <div className="logo">
            <Link to="/"><img src={logoImg} alt="Döner Sonntag" className="logo-img" /></Link>
          </div>
          <div className="nav-right">
            <div className="nav-links">
              <a href="#reviews">Bewertungen</a>
              <a href="#about">Über uns</a>
              <a href="#submit">Tipp geben</a>
            </div>
            <a href="#about" className="nav-disclaimer">Disclaimer</a>
          </div>
        </div>
      </nav>

      <header className="hero">
        <img className="hero-bg-illustration" src={bannerImg} alt="" />
        <div className="hero-content">
          <div className="hero-eyebrow">
            <span className="pulse"></span>
            Jeden Sonntag neu bewertet
          </div>
          <h1> <em>Geschichten</em> zwischen <br />Brot  und Spieß</h1>
          <p className="hero-sub">
            Zwei Freunde, ein Ritual. Jeden Sonntag ein neuer Laden — bewertet mit Herz, Hunger und hohen Ansprüchen.
          </p>
          <div className="stats">
            <div>
              <div className="stat-num">30<span className="accent">+</span></div>
              <div className="stat-label">Bewertungen</div>
            </div>
            <div>
              <div className="stat-num">2</div>
              <div className="stat-label">Experten</div>
            </div>
            <div>
              <div className="stat-num">1<span className="accent">♥</span></div>
              <div className="stat-label">Ritual</div>
            </div>
          </div>
        </div>
      </header>

      <div id="reviews">
        {activateAdding && (
          <div style={{ textAlign: "center", paddingTop: "40px" }}>
            <Link to="/add" className="add-btn">➕ Hinzufügen</Link>
          </div>
        )}
        <Outlet />
      </div>

      <section id="about" className="about">
        <div className="about-inner">
          <span className="about-label">Über uns</span>
          <h2>Zwei Freunde,<br />ein <em>Ritual</em></h2>
          <p>
            Wir sind zwei beste Freunde – verbunden durch ein festes Ritual: Jeden Sonntag suchen wir einen neuen Dönerladen auf, probieren den Döner und teilen anschließend unsere ehrliche Meinung.
          </p>
          <p>
            Aus Spaß wurde Tradition, und aus der Tradition dieser Blog. Hier findet ihr unsere Bewertungen, Eindrücke und vielleicht auch die ein oder andere Empfehlung für euren nächsten Döner-Sonntag.
          </p>
          <p className="disclaimer">
            Alle Bewertungen spiegeln ausschließlich unsere persönliche Meinung wider und stellen keine Tatsachenbehauptungen dar.
          </p>
        </div>
      </section>

      <section id="submit" className="submit">
        <div className="submit-inner">
          <h3>Einen <em>Döner</em><br />vorschlagen</h3>
          <p className="submit-sub">Ihr kennt einen guten Laden? Schreibt uns — vielleicht ist er unser nächster Sonntag.</p>
          <form onSubmit={sendMail}>
            <input type="text" placeholder="Ihr Name" />
            <input type="email" placeholder="Ihre E-Mail" />
            <textarea placeholder="Ladenname, Adresse & eure Meinung"></textarea>
            <button type="submit">Tipp abschicken</button>
          </form>
          <a
            href="https://www.döner-sonntag.de/datenschutz"
            onClick={(e) => { e.preventDefault(); navigate("/datenschutz"); }}
            className="privacy-link"
          >
            * Datenschutz
          </a>
        </div>
      </section>

      <footer onDoubleClick={() => setActivateAdding(true)}>
        <p>Gemacht mit <span className="heart">♥</span> von zwei Döner-Enthusiasten</p>
        <a
          href="https://www.döner-sonntag.de/impressum"
          onClick={(e) => { e.preventDefault(); navigate("/impressum"); }}
          className="footer-link"
        >
          Impressum
        </a>
      </footer>
    </div>
  );
}

export default Hero;
